var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nothing-here-block"},[_vm._v(_vm._s(_vm.outputText))])
}
var staticRenderFns = []

export { render, staticRenderFns }